import { useState, useEffect } from "react";
import { Lightbulb, X } from "lucide-react";
import { getRandomFact, markFactAsViewed } from "../lib/gamification";
import type { SupplementFact } from "../lib/supabase";

export function FunFact() {
  const [fact, setFact] = useState<SupplementFact | null>(null);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    loadFact();
  }, []);

  const loadFact = async () => {
    const randomFact = await getRandomFact();
    setFact(randomFact);
  };

  const handleDismiss = async () => {
    if (fact) {
      await markFactAsViewed(fact.id);
    }
    setVisible(false);
  };

  if (!fact || !visible) {
    return null;
  }

  return (
    <div className="mb-4 animate-fade-in">
      <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200 rounded-2xl p-4 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="bg-amber-400 rounded-full p-2 flex-shrink-0">
            <Lightbulb className="text-white" size={20} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-xs font-semibold text-amber-700 uppercase tracking-wide mb-1">
              Did You Know?
            </div>
            <p className="text-sm text-gray-700 leading-relaxed">
              {fact.fact_text}
            </p>
          </div>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
}
